module.exports = __webpack_public_path__ + "static/media/sessions.d69590c6.mp4";